var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "label-width": "80px",
          "query-params": _vm.queryParams,
          selection: _vm.selection,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          afterFetchOriginalData: _vm.afterFetchOriginalData,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessLogisticsProductLang.productCode"
                          ),
                          prop: "productCode",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessLogisticsProductLang.productCode"
                            ),
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.productCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "productCode", $$v)
                            },
                            expression: "queryParams.productCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessLogisticsProductLang.productName"
                          ),
                          prop: "productName",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessLogisticsProductLang.productName"
                            ),
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.productName,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "productName", $$v)
                            },
                            expression: "queryParams.productName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessLogisticsProductLang.productType"
                          ),
                          prop: "productType",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.PRODUCT_ALL_TYPE_LIST,
                            placeholder: _vm.$t(
                              "BusinessLogisticsProductLang.productType"
                            ),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.productType,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "productType", $$v)
                            },
                            expression: "queryParams.productType",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("BusinessLogisticsProductLang.status"),
                          prop: "status",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.PRODUCT_STATUS_LIST,
                            placeholder: _vm.$t(
                              "BusinessLogisticsProductLang.status"
                            ),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "status", $$v)
                            },
                            expression: "queryParams.status",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function (tableOperationProp) {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.onAdd },
                      },
                      [_vm._v(_vm._s(_vm.$t("addText")))]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "main-btn",
                        attrs: {
                          disabled: tableOperationProp.notSelected,
                          type: "primary",
                        },
                        on: { click: _vm.onDelete },
                      },
                      [_vm._v(_vm._s(_vm.$t("bulkDelText")))]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "scanNode"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.SCAN_NODE_LIST.bjGet(
                                                  scope.row.scanNode
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "productType"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.PRODUCT_ALL_TYPE_LIST.bjGet(
                                                  scope.row.productType
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "orderType"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.ORDER_TYPE_LIST.bjGet(
                                                  scope.row.orderType
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "status"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.PRODUCT_STATUS_LIST.bjGet(
                                                  scope.row.status
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "specialGoodsTypes"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formatSpecialGoodsTypes(
                                                  scope.row.specialGoodsTypes
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "weightUnit"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.WEIGHT_UNIT_LIST.bjGet(
                                                  scope.row.weightUnit
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "lengthUnit"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.LENGTH_UNIT_LIST.bjGet(
                                                  scope.row.lengthUnit
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "deliveryDays"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formatDeliveryDays(
                                                  scope.row
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEdit(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("editText")))]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onSetting(props.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "BusinessLogisticsProductLang.productEdit"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "1000px",
            "append-to-body": "",
            "close-on-click-modal": false,
            "before-close": _vm.handleDialogClose,
            "custom-class": "logistics-product-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "productForm",
              staticClass: "product-form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-position": "top",
              },
            },
            [
              _c("BjDivider", [
                _vm._v(
                  _vm._s(_vm.$t("BusinessLogisticsProductLang.basicInfo"))
                ),
              ]),
              _c(
                "el-row",
                {
                  staticClass: "product-section-content",
                  attrs: { gutter: 40 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "BusinessLogisticsProductLang.productCode"
                            ),
                            prop: "productCode",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              placeholder: _vm.$t(
                                "BusinessLogisticsProductLang.productCodePlaceholder"
                              ),
                            },
                            model: {
                              value: _vm.form.productCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "productCode", $$v)
                              },
                              expression: "form.productCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "BusinessLogisticsProductLang.productName"
                            ),
                            prop: "productName",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              placeholder: _vm.$t(
                                "BusinessLogisticsProductLang.productNamePlaceholder"
                              ),
                            },
                            model: {
                              value: _vm.form.productName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "productName", $$v)
                              },
                              expression: "form.productName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "boolean-form-item",
                          attrs: {
                            label: _vm.$t(
                              "BusinessLogisticsProductLang.allowModifyOrder"
                            ),
                            prop: "allowModifyOrder",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.allowModifyOrder,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "allowModifyOrder", $$v)
                                },
                                expression: "form.allowModifyOrder",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v(_vm._s(_vm.$t("yesText"))),
                              ]),
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v(_vm._s(_vm.$t("noText"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "boolean-form-item",
                          attrs: {
                            label: _vm.$t(
                              "BusinessLogisticsProductLang.arrearsStopService"
                            ),
                            prop: "arrearsStopService",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.arrearsStopService,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "arrearsStopService", $$v)
                                },
                                expression: "form.arrearsStopService",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v(_vm._s(_vm.$t("yesText"))),
                              ]),
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v(_vm._s(_vm.$t("noText"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("BjDivider", [
                _vm._v(
                  _vm._s(_vm.$t("BusinessLogisticsProductLang.goodsConfig"))
                ),
              ]),
              _c(
                "el-row",
                {
                  staticClass: "product-section-content",
                  attrs: { gutter: 40 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "BusinessLogisticsProductLang.specialGoodsType"
                            ),
                            prop: "specialGoodsTypes",
                          },
                        },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              staticClass: "special-goods-group",
                              model: {
                                value: _vm.form.specialGoodsTypes,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "specialGoodsTypes", $$v)
                                },
                                expression: "form.specialGoodsTypes",
                              },
                            },
                            _vm._l(
                              _vm.SPECIAL_GOODS_TYPE_LIST,
                              function (item) {
                                return _c(
                                  "el-checkbox",
                                  {
                                    key: item.value,
                                    attrs: { label: item.value },
                                  },
                                  [_vm._v(" " + _vm._s(item.label) + " ")]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "BusinessLogisticsProductLang.weightUnit"
                            ),
                            prop: "weightUnit",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              "option-list": _vm.WEIGHT_UNIT_LIST,
                              placeholder: _vm.$t("chooseText"),
                            },
                            model: {
                              value: _vm.form.weightUnit,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "weightUnit", $$v)
                              },
                              expression: "form.weightUnit",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "BusinessLogisticsProductLang.lengthUnit"
                            ),
                            prop: "lengthUnit",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              "option-list": _vm.LENGTH_UNIT_LIST,
                              placeholder: _vm.$t("chooseText"),
                            },
                            model: {
                              value: _vm.form.lengthUnit,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "lengthUnit", $$v)
                              },
                              expression: "form.lengthUnit",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("BjDivider", [
                _vm._v(
                  _vm._s(_vm.$t("BusinessLogisticsProductLang.businessConfig"))
                ),
              ]),
              _c(
                "el-row",
                {
                  staticClass: "product-section-content business-config-row",
                  attrs: { gutter: 20 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "business-form-item",
                          attrs: { prop: "scanNode" },
                        },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "BusinessLogisticsProductLang.scanNode"
                                    )
                                  )
                                ),
                              ]),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.$t(
                                      "BusinessLogisticsProductLang.scanNodeTips"
                                    ),
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-question form-tip-icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("BjSelectLov", {
                            attrs: {
                              "option-list": _vm.SCAN_NODE_LIST,
                              placeholder: _vm.$t("chooseText"),
                              disabled: _vm.isEdit,
                            },
                            model: {
                              value: _vm.form.scanNode,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "scanNode", $$v)
                              },
                              expression: "form.scanNode",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "business-form-item",
                          attrs: { prop: "orderType" },
                        },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "BusinessLogisticsProductLang.orderType"
                                    )
                                  )
                                ),
                              ]),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.$t(
                                      "BusinessLogisticsProductLang.orderTypeTips"
                                    ),
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-question form-tip-icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("BjSelectLov", {
                            attrs: {
                              "option-list": _vm.ORDER_TYPE_LIST,
                              placeholder: _vm.$t("chooseText"),
                              disabled: _vm.isEdit,
                            },
                            on: { change: _vm.handleOrderTypeChange },
                            model: {
                              value: _vm.form.orderType,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "orderType", $$v)
                              },
                              expression: "form.orderType",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "business-form-item",
                          attrs: { prop: "productType" },
                        },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "BusinessLogisticsProductLang.productType"
                                    )
                                  )
                                ),
                              ]),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.$t(
                                      "BusinessLogisticsProductLang.orderTypeTips"
                                    ),
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-question form-tip-icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("BjSelectLov", {
                            attrs: {
                              "option-list": _vm.PRODUCT_TYPE_LIST,
                              placeholder: _vm.$t("chooseText"),
                              disabled: _vm.isEdit,
                              loading: _vm.productTypeLoading,
                            },
                            model: {
                              value: _vm.form.productType,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "productType", $$v)
                              },
                              expression: "form.productType",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("BjDivider", [
                _vm._v(
                  _vm._s(_vm.$t("BusinessLogisticsProductLang.otherConfig"))
                ),
              ]),
              _c(
                "el-row",
                {
                  staticClass: "product-section-content",
                  attrs: { gutter: 40 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "BusinessLogisticsProductLang.minDeliveryDays"
                            ),
                            prop: "minDeliveryDays",
                          },
                        },
                        [
                          _c("BjInputNumber", {
                            attrs: {
                              min: 1,
                              precision: 0,
                              placeholder: _vm.$t(
                                "BusinessLogisticsProductLang.minDeliveryDaysPlaceholder"
                              ),
                              "not-auto-zero": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "append",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "BusinessLogisticsProductLang.dayUnit"
                                        )
                                      )
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.form.minDeliveryDays,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "minDeliveryDays", $$v)
                              },
                              expression: "form.minDeliveryDays",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "BusinessLogisticsProductLang.maxDeliveryDays"
                            ),
                            prop: "maxDeliveryDays",
                          },
                        },
                        [
                          _c("BjInputNumber", {
                            attrs: {
                              min: 1,
                              precision: 0,
                              placeholder: _vm.$t(
                                "BusinessLogisticsProductLang.maxDeliveryDaysPlaceholder"
                              ),
                              "not-auto-zero": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "append",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "BusinessLogisticsProductLang.dayUnit"
                                        )
                                      )
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.form.maxDeliveryDays,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "maxDeliveryDays", $$v)
                              },
                              expression: "form.maxDeliveryDays",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "BusinessLogisticsProductLang.sortNum"
                            ),
                            prop: "sortNum",
                          },
                        },
                        [
                          _c("BjInputNumber", {
                            attrs: {
                              min: 0,
                              precision: 0,
                              placeholder: _vm.$t("inputText"),
                              "not-auto-zero": "",
                            },
                            model: {
                              value: _vm.form.sortNum,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "sortNum", $$v)
                              },
                              expression: "form.sortNum",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "BusinessLogisticsProductLang.businessChannel"
                            ),
                            prop: "businessId",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              "option-list": _vm.logisticsChannelAllList,
                              placeholder: _vm.$t(
                                "BusinessLogisticsProductLang.businessChannelPlaceholder"
                              ),
                            },
                            model: {
                              value: _vm.form.businessId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "businessId", $$v)
                              },
                              expression: "form.businessId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleDialogClose } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }